import { useState,useEffect } from 'react'
import Left from '../../components/LeftSide/Left'
import ProfileMiddle from '../../components/Profile/ProfileMiddle'
import Right from '../../components/RightSide/Right'
import Nav from '../../components/SecureNav/Nav'
import "../Profile/Profile.css"
import ProfileImg from "../../assets/profile.jpg"
import { get } from '../../service/apiService';
import axios from 'axios';
import { API_BASE_URL, API_KEY } from '../../constants';
import axiosInstance from '../../axios'

const Profile = () => {
  const [following, setFollowing] = useState(3);
  const [search, setSearch] = useState("");

  const [showMenu, setShowMenu] = useState(false);

  const [images, setImages] = useState(null);

  const [name, setName] = useState("");


  const [userName, setUserName] = useState("");
  var member_id=window.location.href.split("/")[4]
  const [profileImg, setProfileImg] = useState('')
  const [coverImg, setCoverImg] = useState('')
  const [modelDetails, setModelDetails] = useState(
    {
      ModelName: '',
      ModelUserName: '',
      ModelCountryName: "India",
      ModelDob:'',
      ModelId:member_id
    }
  )
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData')) || {};
    if (userData && userData.user_profile.member_id === member_id) {
      const profilePicUrl = userData.member_details?.profile_pic || '';
      const coverPicUrl = userData.member_details?.cover_pic || '';
      const dob = userData.member_details?.dob || '';
      const member_name = userData.user_profile?.first_name || '';
      const member_email = userData.user_profile?.email || '';

      setModelDetails({
        ModelName: member_name,
        ModelUserName: member_email,
        ModelCountryName: "India",
        ModelDob: dob,
        ModelId: member_id
      });
      setProfileImg(profilePicUrl);
      setCoverImg(coverPicUrl);
    } else {
      axiosInstance.get(`${API_BASE_URL}members-all-info/${member_id}`)
        .then(responseData => {
          try {
            if (responseData && responseData.data) {
              const member_details = responseData.data.data.member_details;
              setModelDetails({
                ModelName: member_details.first_name,
                ModelUserName: responseData.data.data.member.email,
                ModelCountryName: "India",
                ModelDob: member_details.dob,
                ModelId: member_id
              });
              setProfileImg(member_details.profile_pic);
              setCoverImg(member_details.cover_pic);
            }
          } catch (error) {
            console.error("An error occurred while fetching data:", error);
          }
        });
    }
  }, [member_id]); 
  
  return (
    <div className='interface'>
      <Nav
        search={search}
        setSearch={setSearch}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
        profileImg={profileImg}
      />
      <div className="home">
        <Left
        member_id={member_id}
        />

        <ProfileMiddle
          following={following}
          search={search}
          images={images}
          setImages={setImages}
          name={name}
          setName={setName}
          userName={userName}
          setUserName={setUserName}
          profileImg={profileImg}
          coverImg={coverImg}
          setProfileImg={setProfileImg}
          setCoverImg={setCoverImg}
          modelDetails={modelDetails}
          setModelDetails={setModelDetails}
        />

        <Right
        />
      </div>
    </div>
  )
}

export default Profile